// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail_container__HrvOP {
  margin-left: calc(var(--sidebar-width) + 20px);
  display: flex;
  justify-content: space-between;
  height: 100%;
}

.detail_outputContainer__A6NjQ {
  min-width: 760px;
}

.detail_outputContainer__A6NjQ,
.detail_detailContainer__ldDLl {
  overflow-y: scroll;
  flex-basis: 47%;
  height: 100%;
}

.detail_detailContainer__ldDLl {
  background-color: #ecf0f8;
  padding: 24px;
  border-radius: 15px;
  font-family: Mulish, sans-serif;
  height: calc(100% - 30px);
  box-shadow:
    0 3px 18px 1px #00206b33,
    -1px 2px 3px -2px #00206b40;
  margin-right: 20px;
}

.detail_frequency__My76J {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background-color: #eeeeee;
  color: #375395;
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-left: 5px;
  height: 40px;
}

.detail_frequency__My76J>div {
  padding-left: 5px;
  color: #37539580;
}

.detail_selected__QGI1B {
  background-color: #375395;
  color: white;
}

.detail_spinner__J14pi {
  margin-left: 8px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: detail_spin__3Y5aJ 1s linear infinite;
}

@keyframes detail_spin__3Y5aJ {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.detail_selected__QGI1B {
  background-color: #375395;
  /* Color de fondo cuando está seleccionado */
  color: white;
  /* Color del texto cuando está seleccionado */
}`, "",{"version":3,"sources":["webpack://./src/screens/detail/detail.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB;;+BAE6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,YAAY;EACZ,6CAA6C;AAC/C","sourcesContent":[".container {\n  margin-left: calc(var(--sidebar-width) + 20px);\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.outputContainer {\n  min-width: 760px;\n}\n\n.outputContainer,\n.detailContainer {\n  overflow-y: scroll;\n  flex-basis: 47%;\n  height: 100%;\n}\n\n.detailContainer {\n  background-color: #ecf0f8;\n  padding: 24px;\n  border-radius: 15px;\n  font-family: Mulish, sans-serif;\n  height: calc(100% - 30px);\n  box-shadow:\n    0 3px 18px 1px #00206b33,\n    -1px 2px 3px -2px #00206b40;\n  margin-right: 20px;\n}\n\n.frequency {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 13px;\n  background-color: #eeeeee;\n  color: #375395;\n  display: flex;\n  padding: 5px 10px;\n  cursor: pointer;\n  user-select: none;\n  margin-left: 5px;\n  height: 40px;\n}\n\n.frequency>div {\n  padding-left: 5px;\n  color: #37539580;\n}\n\n.selected {\n  background-color: #375395;\n  color: white;\n}\n\n.spinner {\n  margin-left: 8px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.selected {\n  background-color: #375395;\n  /* Color de fondo cuando está seleccionado */\n  color: white;\n  /* Color del texto cuando está seleccionado */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `detail_container__HrvOP`,
	"outputContainer": `detail_outputContainer__A6NjQ`,
	"detailContainer": `detail_detailContainer__ldDLl`,
	"frequency": `detail_frequency__My76J`,
	"selected": `detail_selected__QGI1B`,
	"spinner": `detail_spinner__J14pi`,
	"spin": `detail_spin__3Y5aJ`
};
export default ___CSS_LOADER_EXPORT___;
